import { Button } from "@/components/ui/button";

export default function ColorBarCTA({ cta, style }) {
  const color = cta.color ? cta.color : "";
  
  // Replace eval with a safer approach
  const storylaneFunc = cta.storylaneCode ? 
    () => {
      // If you need to execute storylane code, consider using a safer method
      // For example, storing predefined functions in an object
      const storylaneFunctions = {
        // Add your storylane functions here
        // example: 'openStoryline': () => window.open('...'),
      };
      return storylaneFunctions[cta.storylaneCode] || (() => {});
    } : 
    () => {};

  const buttonType =
    color === "orange"
      ? "primary"
      : color === "green"
        ? "green"
        : color === "blue"
          ? "seablue"
          : color === "yellow"
            ? "yellow"
            : "secondary";

  return (
    <div style={style}>
      <section className={`cta-bar-${color}`}>
        <div className="w-layout-blockcontainer container-1200 w-container">
          <div className="w-layout-grid cta-bar-grid">
            <div className="cta-bar__content">
              {cta.name && <h4 className={`heading-3 ${color}`}>{cta.name}</h4>}
              {cta.description && (
                <p className={`body-text mb-0 feature semi-bold ${color} ${buttonType}`}>
                  {cta.description}
                </p>
              )}
            </div>

            <Button
              url={cta.url}
              size="small"
              variant={buttonType}
              onClick={storylaneFunc}
            >
              {cta.buttonText}
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
}
